import { type Action } from "redux"

// Model imports

export enum CreditCardActionTypes {
    FETCH_ALL_CARDS = "FETCH_ALL_CARDS",
    SET_SHOULD_REFETCH_CARDS = "SET_SHOULD_REFETCH_CARDS",
}

// TODO: type
export interface FetchAllCardsAction extends Action<typeof CreditCardActionTypes.FETCH_ALL_CARDS> {
    type: typeof CreditCardActionTypes.FETCH_ALL_CARDS
    cards: Array<any>
    totalPages: number
    totalDocs: number
    append: boolean
}

export interface SetShouldRefetchCardsAction extends Action<typeof CreditCardActionTypes.SET_SHOULD_REFETCH_CARDS> {
    type: typeof CreditCardActionTypes.SET_SHOULD_REFETCH_CARDS
    shouldRefetch: boolean
}

export type CreditCardActions = FetchAllCardsAction | SetShouldRefetchCardsAction
